import {getNorthVDData, getMiddleVDData, getSouthVDData} from '../../api/trafficVDApi'
import Utils from '../../utils/utils'
import CONST from '../../utils/const'

const state = {
    VDData: {}
}

const getters = {
    getVDData: state => {
        return state.VDData
    }
}

const actions = {
    async updatetNorthVDData({ commit }, condition) {
        commit('northVDData', await getNorthVDData(condition))
    },
    async updatetMiddleVDData({ commit }, condition) {
        commit('middleVDData', await getMiddleVDData(condition))
    },
    async updatetSouthVDData({ commit }, condition) {
        commit('southVDData', await getSouthVDData(condition))
    },
    async updateVDData({commit}, condition) {
        commit('northVDData', await getNorthVDData(condition))
        commit('middleVDData', await getMiddleVDData(condition))
        commit('southVDData', await getSouthVDData(condition))
    }
}

const mutations ={
    northVDData(state, data) {
        if(!Utils.isEmptyObject(data)) {
            state.VDData[CONST.VD_ID.NORTH] = data
        }
            
    },
    middleVDData(state, data) {
        if(!Utils.isEmptyObject(data)) {
            state.VDData[CONST.VD_ID.MIDDLE] = data
        }
            
    },
    southVDData(state, data) {
        if(!Utils.isEmptyObject(data)) {
            state.VDData[CONST.VD_ID.SOUTH] = data
        }
            
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }